import * as Yup from "yup";

export const PickupDetailsvalidation = Yup.object().shape({
  ContactName: Yup.string()
    .required("Contact name is required")
    .min(2, "Contact name must be at least 2 characters long"),
  phoneNumber: Yup.number().required("Phone Number is required"),
  EmailAddress: Yup.string().email().required("Email is required"),
  Location: Yup.string().required("Location is required"),
});
export const DeliveryDetailsvalidation = Yup.object().shape({
  ContactName: Yup.string().required("Contact name is required"),
  phoneNumber: Yup.number().required("Phone Number is required"),
  EmailAddress: Yup.string().email().required("Email is required"),
  Location: Yup.string().required("Location is required"),
});
export const QuotationOrderDetailsvalidation = Yup.object().shape({
  CargoName: Yup.string().required("Cargo name is required"),
  Length: Yup.number()
    .required("Length is required")
    .positive("Length must be a positive number"),
  WidthLbs: Yup.number()
    .required("Width is required")
    .positive("Width must be a positive number"),
  WidthIn: Yup.number()
    .required("Width is required")
    .positive("Width must be a positive number"),
  HeightIn: Yup.number()
    .required("Height is required")
    .positive("Height must be a positive number"),
  CargoImages: Yup.array().min(1, "Please select at least one image"),
  DateTime: Yup.date().required("DateTime is required"),
  CargoDescription: Yup.string().required("Cargo description is required"),
});
